<div class="overlay">
    <div class="col-sm-3 p-2 popup-container">
        <loading-spinner></loading-spinner>
        <div class="card card-1 border border-primary p-1 z-depth-1">
            <div class="card-body text-center">
                <h5 class="card-title"><b>Email notifications disabled</b></h5>
                <p class="card-text">
                    We will no longer send email notification to your inbox
                </p>
                <div>
                    <button mdbBtn mdbWavesEffect (click)="goToApp()" color="blue" class="btn btn-sm">Go to app</button>
                </div>
            </div>
        </div>
    </div>
</div>